import SectionHub from '@/components/docs/SectionHub';

export default function Docs02AlternativeDataHub() {
  return <SectionHub sectionPath="02-alternative-data" />;
}
